import React from 'react';
import importedStyles from "./Snack.module.sass";
import Snackbar from '@material-ui/core/Snackbar';
import connect from "react-redux/es/connect/connect";
import {showSnack} from '../../components/Snack/SnackActions';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';

class Snack extends React.Component {

    state = {
        snackData: {},
    };

    render() {
        const snackData = this.props.snackData;
        let style = importedStyles[snackData.snackType === '' ? snackData.oldSnackType : snackData.snackType];

        return (
            <div className={importedStyles.snackParentWrapper}>
                <Snackbar
                    className={style}
                    message={snackData.text}
                    open={snackData.show}
                    autoHideDuration={10000}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                    onClose={() => this.props.dispatch(showSnack('', '', false))}
                    action={
                        <IconButton
                            size={"small"}
                            key="close"
                            aria-label="Close"
                            className={importedStyles.snackButton}
                            variant={"outlined"}
                            onClick={() => this.props.dispatch(showSnack('', '', false))}
                        >
                            <CloseIcon/>
                        </IconButton>
                    }
                />
         </div>
        );
    }
}
const mapStateToProps = ({snackReducer}) => {
    return ({
        snackData: snackReducer.data,
    });
};

export default connect(mapStateToProps)(Snack);